export Battery from './Battery';
export Bubble from './Bubble';
export Bubbles from './Bubbles';
export BubbleCollection from './Bubble-collection';
export BubbleSlide from './Bubble-slide';
export Button from './Button';
export Cat from './Cat';
export Cam from './Cam';
export Code from './Code';
export CodeCaption from './Code-caption';
export Container from './Container';
export Footer from './Footer';
export HeadTracking from './Head-tracking';
export Icon from './Icon';
export Loader from './Loader';
export Location from './Location';
export LocationBubble from './Location-bubble';
export Map from './Map';
export Mouse from './Mouse';
export News from './News';
export Notification from './Notification';
export Places from './Places';
export Reminder from './Reminder';
export Slide from './Slide';
export SpeechRecognition from './Speech-recognition';
export Weather from './Weather';



// WEBPACK FOOTER //
// ./src/js/Components/index.js